import { useState, useEffect } from 'react';
import '../styles/ActionButtons.css';
import './ProductCartCounter.css';

const ProductCartCounter = ({ product, onAddToCart, disabled = false, initialQuantity = 0, quantityLabel = 'Quantity' }) => {
  const [quantity, setQuantity] = useState(initialQuantity);

  // Update quantity when initialQuantity prop changes
  useEffect(() => {
    setQuantity(initialQuantity);
  }, [initialQuantity]);

  const handleAddToCart = () => {
    if (disabled) return;
    
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);
    
    // Call the parent's onAddToCart callback if provided
    if (onAddToCart) {
      onAddToCart(product, newQuantity);
    }
  };

  const handleDecrease = (e) => {
    e.stopPropagation();
    if (quantity > 0) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      
      // Call the parent's onAddToCart callback with updated quantity
      if (onAddToCart) {
        onAddToCart(product, newQuantity);
      }
    }
  };

  const handleIncrease = (e) => {
    e.stopPropagation();
    if (disabled) return;
    
    const newQuantity = quantity + 1;
    setQuantity(newQuantity);
    
    // Call the parent's onAddToCart callback with updated quantity
    if (onAddToCart) {
      onAddToCart(product, newQuantity);
    }
  };

  // If quantity is 0, show the add button
  if (quantity === 0) {
    return (
      <button
        type="button"
        className="skin-action-button add-to-cart-button"
        disabled={disabled}
        onClick={handleAddToCart}
      >
        Add to Suggestions
      </button>
    );
  }

  // If quantity > 0, show the quantity counter
  return (
    <div className="product-cart-counter">
      <button
        type="button"
        className="cart-counter-button cart-counter-decrease"
        onClick={handleDecrease}
        aria-label="Decrease quantity"
      >
        −
      </button>
      <div className="cart-counter-quantity">
        <span className="cart-counter-label">{quantityLabel}:</span>
        <span className="cart-counter-value">{quantity}</span>
      </div>
      <button
        type="button"
        className="cart-counter-button cart-counter-increase"
        onClick={handleIncrease}
        disabled={disabled}
        aria-label="Increase quantity"
      >
        +
      </button>
    </div>
  );
};

export default ProductCartCounter;

